import React from 'react';
import { makeStyles } from 'tss-react/mui';
import MySlider from '../../../../components/MySlider/MySlider';

const useStyles = makeStyles()({
  root: {
    '--my-slider-width': '100%',
    '--my-slider-padding': '6px 0 20px 0',
    '--my-slider-margin-left': '0px'
  },
  thumb: {
    height: 24,
    width: 24
    // v9: do NOT add marginTop/marginLeft to manually offset the thumb.
    // v9's Slider centers the thumb via `transform: translate(-50%, -50%)`.
    // The legacy v4 `marginTop: -9, marginLeft: -11` hack (used to lift the
    // thumb onto a thicker rail in v4) now stacks on top of the transform
    // and visibly pushes the thumb 9px up + 11px left of the rail — which
    // is exactly what user reported.
  },
  track: {
    height: 8
  },
  rail: {
    height: 8
  }
});

const InputPanelSlider = props => {
  const { ...rest } = props;
  const { classes } = useStyles();
  return <MySlider classes={classes} {...rest} />;
};

export default InputPanelSlider;
